import * as React from "react";
import { useDispatch } from "@teamprevent/admin-redux";
import { Button, Form, Modal } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { goToParent } from "@teamprevent/common/routing";
import { toast } from "@teamprevent/common/toasts";

import { SelfServiceCheckInApi } from "../../SelfServiceCheckInApi";
import { AllowableSelfServiceCheckInIPAddress, isIPAddressValid } from "../../models";

type Props = {
    onAllowableIPAddressCreated: (ipAddress: AllowableSelfServiceCheckInIPAddress) => void;
}

export const CreateAllowableIPAddress: React.FunctionComponent<Props> = (props: Props) => {
    const [submitted, setSubmitted] = React.useState(false);
    const [description, setDescription] = React.useState("");
    const [ipAddress, setIPAddress] = React.useState("");
    const [active, setActive] = React.useState(true);
    const [saving, setSaving] = React.useState(false);
    const dispatch = useDispatch();

    const onClose = () => dispatch(goToParent());

    const onSave = async () => {
        setSubmitted(true);
        const descriptionTrimmed = description.trim();
        const ipAddressTrimmed = ipAddress.trim();
        if (!descriptionTrimmed || !ipAddressTrimmed) {
            return;
        }
        if (!isIPAddressValid(ipAddressTrimmed)) {
            toast.warning("IP Address is not valid!");
            return;
        }
        setSaving(true);
        const createdAllowableEmailTemplate = await SelfServiceCheckInApi.create({ description: descriptionTrimmed, value: ipAddressTrimmed, active });
        props.onAllowableIPAddressCreated(createdAllowableEmailTemplate);
        setSaving(false);
        onClose();
    };

    return (
        <Modal open size="small" closeOnDimmerClick={false}>
            <Modal.Header>Create Self Service Check In Allowable IP Address</Modal.Header>
            <Modal.Content>
                <Form>
                    <Input.Text required showErrors={submitted} label="Description" onChange={setDescription} value={description} />
                    <div className={"fields-divider"} />
                    <Input.Text required showErrors={submitted} label="IP Address" onChange={setIPAddress} value={ipAddress} />
                    <div className={"fields-divider"} />
                    <Input.Checkbox showErrors={submitted} label="Active" onChange={setActive} value={active} />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose}>Cancel</Button>
                <Button loading={saving} disabled={saving} content="Save" onClick={onSave} />
            </Modal.Actions>
        </Modal>
    );
};
